import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInvitationFlows } from '@guryou/redux';

import { StateStatus } from '../core';

const useInvitationFlows = () => {
  const dispatch = useDispatch();

  const { data, status, version, entity } = useSelector(state => state.customersInvitationFlow.all);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getInvitationFlows());
    }
  }, [dispatch, status]);

  return { data: data || [], status, version, entity };
};

export default useInvitationFlows;
